import React from 'react';
import InView from 'react-intersection-observer';
import { Link } from 'react-router-dom';

export const DroneSoccerSimulator = () => {
  return (
    <section className="soccer-simulator-section">
      <div className="soccer-simulator-text">
        <div className="soccer-simulator-titles">
          <h2 className="soccer-simulator-subtitle">
            GAME-CHANGING & EDUCATIONAL
          </h2>
          <h3 className="soccer-simulator-title">DRONE SOCCER SOLUTIONS</h3>
        </div>
        <p className="soccer-simulator-description">
          Our one-of-a-kind simulator game mode delivers structured,{' '}
          <span style={{ whiteSpace: 'nowrap' }}>scenario-driven</span> training
          and competition to help students and teams hone their skills with
          precision.
        </p>
        <div className="soccer-simulator-buttons">
          <div className="dreamX__discover--button">
            <a
              style={{ minWidth: '213.45px' }}
              href="https://store.steampowered.com/app/3896940/Drone_Soccer/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--primary btn--med"
              onMouseDown={event => event.preventDefault()}
            >
              BUY DLC
            </a>
          </div>

          <div className="dreamX__discover--button">
            <Link
              to="/products/skydive"
              rel="noopener noreferrer"
              className="btn btn--primary btn--med"
              onMouseDown={event => event.preventDefault()}
            >
              Learn More
            </Link>
          </div>
        </div>
      </div>

      <div className="soccer-simulator-video-container">
        <InView triggerOnce>
          {({ ref, inView }) => (
            <video
              ref={ref}
              className="soccer-classroom-video"
              muted
              autoPlay
              loop={inView}
              playsInline
            >
              <source
                src="https://cdn.orqafpv.com/website/DroneSoccerSimulator.mp4"
                type="video/mp4"
              />
            </video>
          )}
        </InView>
      </div>
    </section>
  );
};
